import React from 'react';
import PropTypes from 'prop-types';
import EventItem from '../EventItem/EventItem.jsx';

const EventList = ({events, currentPage}) => {
    return (
        <>
            {(events.length && (
                <ul className="tw-m-0 tw-list-none tw-p-0">
                    {events.slice(0, 20 * currentPage).map((event, index) => {
                        return (
                            <EventItem
                                key={index}
                                description={event.description}
                                name={event.name}
                                url={event.url}
                                tags={[event.tag]}
                                targetGroups={event.targetGroup}
                                image={event.image}
                                image_alt={event.image_alt}
                                startDate={event.startDate}
                                endDate={event.endDate}
                            />
                        );
                    })}
                </ul>
            )) || <div className="tw-mt-4 tw-text-center">Niestety, nie ma wydarzeń spełniających wybrane kryteria.</div>}
        </>
    );
};

EventList.propTypes = {
    events: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
};

export default EventList;
